import type { DomainMapper } from '../types';

const se: DomainMapper = {
  countryCode: 'se',
  currency: 'SEK',
  domain: 'localhost:3011',
  environment: 'local',
  flagUrl: '/flags/1x1/SE.svg',
  languagePrimary: true,
  locale: 'sv',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-se.xml',
  storyblokBasePath: 'se',
  url: 'https://localhost:3011/se',
  algoliaIndex: 'b2b-se-sv-SE-products',
  algoliaIndexAutocomplete: 'b2b-se-sv-SE-products_query_suggestions',
  algoliaIndexPages: 'content_',
  //applicationId: 1156, // stage
  applicationId: 1155, // prod
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    //applicationId: 1156, // stage
    applicationId: 1155, // prod
    algoliaIndex: 'b2b-se-sv-SE-products',
    algoliaIndexAutocomplete: 'b2b-se-sv-SE-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-se.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: false,
    purchaseEnabled: false,
    storyblokBasePath: '',
    applicationId: 1156, // stage
    algoliaIndex: 'b2b-se-sv-SE-products',
    algoliaIndexAutocomplete: 'b2b-se-sv-SE-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'product',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-se-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default se;
